<template>
  <div class="faq-section" data-aos="zoom-in" data-aos-duration="6000">
    <div class="container">
        <div class="row d-flex justify-content-center">
          <h2 class="faq-title">{{ faqTitle }}</h2>
          <div class="col-12 col-lg-10">
            <div class="faq-accordion-list">
              <div
                v-for="(item, idx) in faqs"
                :key="idx"
                class="faq-accordion-item"
                :class="{ open: openIdx === idx }"
              >
                <button class="faq-toggle" @click="toggle(idx)">
                  <span class="faq-icon" :class="{ rotated: openIdx === idx }">
                    {{ openIdx === idx ? '–' : '+' }}
                  </span>
                  <!-- <span class="faq-icon" :class="{ rotated: openIdx === idx }">▼</span> -->
                  <!-- <span class="faq-icon">{{ openIdx === idx ? '–' : '+' }}</span> -->
                  <span class="faq-q">{{ item.question }}</span>
                </button>

                <!-- Transición para la respuesta -->
                <transition name="faq-fade">
                  <div class="faq-answer" v-show="openIdx === idx">
                    {{ item.answer }}
                  </div>
                </transition>
              </div>
            </div>
          </div>
         
        </div>
    </div>
    
   
  </div>
</template>

<script>
import AOS from 'aos'
import 'aos/dist/aos.css'

export default {
  name: "FrequentAsk",
  props: {
    faqs: { type: Array, required: true },
    faqTitle: { type: String, default: "Preguntas frecuentes" }
  },
  data() {
    return { openIdx: 0 }; // Por defecto el primero abierto
  },
  methods: {
    toggle(idx) {
      this.openIdx = this.openIdx === idx ? null : idx;
    }
  },
  mounted() {
    AOS.init({
      duration: 800,
      once: true
    });
    setTimeout(() => AOS.refresh(), 300);
  }
};
</script>

<style scoped>
.faq-section {
  width: 100%;
  padding: 12px 0 0 0;
}
.faq-title {
  font-family: 'Caveat-Bold', cursive;
  font-size: 2.2rem;
  font-weight: 500;
 
  transition: color 0.3s ease;
  position: relative;
  display: inline-block;
  text-align: justify;
}

.faq-title:hover::after{
  width: 100%;
}
.faq-accordion-list {
  margin-top: 3px;
  width: 100%;
}
.faq-accordion-item {
  border-bottom: 1.5px solid #222;
  padding: 0.35rem 0;
  transition: background 0.14s;
  background: none;
}
.faq-accordion-item.open {
  background: #fafbfc;
}
.faq-toggle {
  width: 100%;
  background: none;
  border: none;
  padding: 0;
  font-family: 'IBM Plex Mono', monospace;
  font-size: 1rem;
  text-align: justify;
  display: flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
  color: #111;
  outline: none;
}
.faq-icon {
  font-size: 1.4rem;
  width: 30px;
  display: inline-block;
  text-align: justify;
  font-weight: 700;
  color: #222;
  transition: transform 0.25s ease, color 0.25s ease;
}
.faq-icon.rotated {
  transform: scale(1.15);
  /* color: #2a6bff; */
}
.faq-q {
  font-weight: bold;
  font-family: 'IBM Plex Mono', monospace;
  font-size: 1.01rem;
}
.faq-answer {
  padding-left: 38px;
  margin-top: 5px;
  font-family: 'IBM Plex Mono', monospace;
  font-size: 0.98rem;
  color: #444;
  transition: all 0.2s;
  white-space: pre-line;
}

.faq-fade-enter-active, .faq-fade-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}
.faq-fade-enter-from, .faq-fade-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(-6px);
}
.faq-fade-enter-to, .faq-fade-leave-from {
  max-height: 300px; 
  opacity: 1;
  transform: translateY(0);
}
.faq-icon {
  font-size: 1.2rem;
  width: 30px;
  display: inline-block;
  text-align: justify;
  font-weight: 700;
  color: #222;
  transition: transform 0.3s ease;
}

.faq-icon.rotated {
  transform: rotate(180deg);
}
</style>
